// ✅ Short 'success' beep
export const beepSuccess = () => {
  const audio = new Audio(
    "data:audio/wav;base64,UklGRtIBAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQ0BAAAAP///wAAAP///wAAAP///wAAAP///wAAAP///wAA"
  );
  audio.volume = 0.4;
  audio.play().catch(() => {});
};

// ✅ Short 'error' beep
export const beepError = () => {
  const audio = new Audio(
    "data:audio/wav;base64,UklGRuIBAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YY0BAAAA////////AP///wD////A////AP///wD////A"
  );
  audio.volume = 0.5;
  audio.play().catch(() => {});
};

// ✅ CRM follow-up reminder chime — a distinct two-note "ding-dong", so it
// doesn't get confused with the POS success/error beeps above. Synthesized
// with the Web Audio API instead of a data-URI, since a clean two-tone
// chime is easier to get right that way than hand-encoding WAV bytes.
export const beepReminder = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();

    const playTone = (freq, startTime, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, startTime);
      gain.gain.exponentialRampToValueAtTime(0.3, startTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startTime);
      osc.stop(startTime + duration);
    };

    const now = ctx.currentTime;
    playTone(740, now, 0.18);
    playTone(988, now + 0.2, 0.22);
  } catch {
    // Autoplay/AudioContext restrictions should never block the reminder
    // itself from showing — the sound is a nice-to-have, not a dependency.
  }
};
